import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import { useContext } from "react";
import { GenerateDeliveryNotePdfActionContext } from "./GenerateDeliveryNotePdfActionContext";

function useGenerateDeliveryNotePdf() {
  const errorHandler = useErrorHandler();
  const { setShowModal, setLoading, sendToCustomer } = useContext(GenerateDeliveryNotePdfActionContext);

  return (deliveryNoteId: string | number, onSuccess?: () => void) => {
    setLoading(true);
    store(`invoices/${deliveryNoteId}/generate-pdf`, {
      send_to_customer: sendToCustomer
    })
      .then(() => {
        setShowModal(false);
        if (onSuccess) onSuccess();
      })
      .catch((error: any) => {
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (status === 422 && data?.errors && Array.isArray(data.errors)) {
          const ids = data.errors
            .map((e: any) => e.booking_id)
            .filter((id: any) => id !== undefined && id !== null);
          if (ids.length > 0) {
            const message = `${data.message || 'Faltan datos de facturación'}\n${'Reservas afectadas'}: ${ids.join(', ')}`;
            errorHandler({ response: { data: { message } } });
          } else {
            errorHandler({ response: { data: { message: data.message || 'Error de validación' } } });
          }
          return;
        }
        errorHandler(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useGenerateDeliveryNotePdf;
